import { useContext, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { ScreenSizeContext } from '@context';
import { SideBarItemType } from '@types';

import { SideBarItem } from './SideBarItem';

import styles from './sidebarList.module.scss';

export interface SideBarItemsListProps {
	options: SideBarItemType[];
	fade?: boolean;
}

export const SideBarItemsList = ({ options, fade }: SideBarItemsListProps) => {
	const pathname = usePathname();
	const { isSmallDT } = useContext(ScreenSizeContext);
	const [itemSelected, setItemSelected] = useState<number>(-1);

	useEffect(() => {
		if (pathname === '/') {
			setItemSelected(-1);
		}
	}, [pathname]);

	const handleIconClick = (targetItem: number) => {
		setItemSelected(targetItem);
	};

	return (
		<>
			{!isSmallDT && (
				<div className={` ${styles[`backdrop`]} ${styles[`backdrop${fade && '-show'}`]} `} />
			)}
			<div className={styles.wrapper} data-testid="menu">
				{options
					.filter(option => !option.disabled)
					.map((option, index) => (
						<div
							className={styles.container}
							role="menuitem"
							aria-label={option.name}
							key={index}
							onClick={() => handleIconClick(index)}
							tabIndex={0}
							data-testid={option?.url.replace('/', '')}
						>
							<SideBarItem menuItem={option} key={option.id} selected={itemSelected === index} />
							{index !== options.length - 1 && !isSmallDT && <div className={styles.separator} />}
						</div>
					))}
			</div>
		</>
	);
};
